import { useState, useCallback, useMemo } from 'react';
import Cookies from 'js-cookie';

const useCookie = cookieName => {
  const [value, setValue] = useState(() => Cookies.get(cookieName) || null);
  const updateCookie = useCallback((newValue, options) => {
    Cookies.set(cookieName, newValue, options);
    setValue(newValue);
  }, [cookieName]);
  const deleteCookie = useCallback(() => {
    Cookies.remove(cookieName);
    setValue(null);
  }, [cookieName]);
  return useMemo(() => [value, updateCookie, deleteCookie], [value, updateCookie, deleteCookie]);
};
var useCookie$1 = useCookie;

export { useCookie$1 as default };
